export const API_GET_ALL_CAMPAIGNS = "API_GET_ALL_CAMPAIGNS";
export const API_GET_ALL_CAMPAIGNS_SUCCESS = "API_GET_ALL_CAMPAIGNS_SUCCESS";
export const API_GET_ALL_CAMPAIGNS_FAIL = "API_GET_ALL_CAMPAIGNS_FAIL";

export const API_ADMIN_GET_ALL_CAMPAIGNS = "API_ADMIN_GET_ALL_CAMPAIGNS";
export const API_ADMIN_GET_ALL_CAMPAIGNS_SUCCESS = "API_ADMIN_GET_ALL_CAMPAIGNS_SUCCESS";
export const API_ADMIN_GET_ALL_CAMPAIGNS_FAIL = "API_ADMIN_GET_ALL_CAMPAIGNS_FAIL";

export const API_ADMIN_GET_CAMPAIGN = "API_ADMIN_GET_CAMPAIGN";
export const API_ADMIN_GET_CAMPAIGN_SUCCESS = "API_ADMIN_GET_CAMPAIGN_SUCCESS";
export const API_ADMIN_GET_CAMPAIGN_FAIL = "API_ADMIN_GET_CAMPAIGN_FAIL";

export const API_ADMIN_PATCH_CAMPAIGN = "API_ADMIN_PATCH_CAMPAIGN";
export const API_ADMIN_PATCH_CAMPAIGN_SUCCESS = "API_ADMIN_PATCH_CAMPAIGN_SUCCESS";
export const API_ADMIN_PATCH_CAMPAIGN_FAIL = "API_ADMIN_PATCH_CAMPAIGN_FAIL";

export const API_ADMIN_POST_CAMPAIGN = "API_ADMIN_POST_CAMPAIGN";
export const API_ADMIN_POST_CAMPAIGN_SUCCESS = "API_ADMIN_POST_CAMPAIGN_SUCCESS";
export const API_ADMIN_POST_CAMPAIGN_FAIL = "API_ADMIN_POST_CAMPAIGN_FAIL";

export const API_ADMIN_DELETE_CAMPAIGN = "API_ADMIN_DELETE_CAMPAIGN";
export const API_ADMIN_DELETE_CAMPAIGN_SUCCESS = "API_ADMIN_DELETE_CAMPAIGN_SUCCESS";
export const API_ADMIN_DELETE_CAMPAIGN_FAIL = "API_ADMIN_DELETE_CAMPAIGN_FAIL";

export const RESET_CAMPAIGN = "RESET_CAMPAIGN";

export const SET_CAMPAIGN = "SET_CAMPAIGN";
export const SET_CAMPAIGN_SUCCESS = "SET_CAMPAIGN_SUCCESS";
export const SET_CAMPAIGN_FAIL = "SET_CAMPAIGN_FAIL";

export const GET_CAMPAIGN_USERS = "GET_CAMPAIGN_USERS";

export const ADMIN_INIT_NEW_CAMPAIGN = "ADMIN_INIT_NEW_CAMPAIGN";

export const ADMIN_RESET_FOCUS_CAMPAIGN = "ADMIN_RESET_FOCUS_CAMPAIGN";

export const API_POST_CAMPAIGN_FILE = "API_POST_CAMPAIGN_FILE";

export const API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN = "API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN";
export const API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_SUCCESS = "API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_SUCCESS";
export const API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_FAIL = "API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_FAIL";

export const API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT = "API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_NEXT";

export const API_POST_CAMPAIGN_ASSIGNATION = "API_POST_CAMPAIGN_ASSIGNATION";

export const API_PUT_CANCEL_CAMPAIGN_ASSIGNATION = "API_PUT_CANCEL_CAMPAIGN_ASSIGNATION";

export const API_GET_CAMPAIGN_RESULT_QR_CODE = "API_GET_CAMPAIGN_RESULT_QR_CODE";
export const API_GET_CAMPAIGN_RESULT_QR_CODE_SUCCESS = "API_GET_CAMPAIGN_RESULT_QR_CODE_SUCCESS";
export const API_GET_CAMPAIGN_RESULT_QR_CODE_FAIL = "API_GET_CAMPAIGN_RESULT_QR_CODE_FAIL";

export const API_SEARCH_CAMPAIGN_RESULTS = "API_SEARCH_CAMPAIGN_RESULTS";
export const API_SEARCH_CAMPAIGN_RESULTS_FAIL = "API_SEARCH_CAMPAIGN_RESULTS_FAIL";
export const API_SEARCH_CAMPAIGN_RESULTS_SUCCESS = "API_SEARCH_CAMPAIGN_RESULTS_SUCCESS";

export const API_GET_CSV_TEMPLATE = "API_GET_CSV_TEMPLATE";
export const API_GET_CAMPAIGN_EXPORT = "API_GET_CAMPAIGN_EXPORT";

export const API_GET_CAMPAIGNS_RECORDS_PAGE = "API_GET_CAMPAIGNS_RECORDS_PAGE";
export const API_GET_CAMPAIGNS_RECORDS_PAGE_SUCCESS = "API_GET_CAMPAIGNS_RECORDS_PAGE_SUCCESS";

export const SET_QR_SEARCH_CAMPAIGN = "SET_QR_SEARCH_CAMPAIGN";
